import { Component, Inject, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import { MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, Validators } from '@angular/forms';
import { DatabaseService } from 'src/app/_services/database.service';

@Component({
  selector: 'app-payment-status-model',
  templateUrl: './status-model.component.html'
})
export class RedeemRequestStatusModelComponent implements OnInit {
  
  constructor(public db:DatabaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _location: Location) { }
  // data:any = this.db.redeemRequestData
  ngOnInit() {
    
    this.formsInit(this.data);
  }
  
  form: FormGroup;
  formsInit(data:any) {
    console.log(data);
    
    this.form = this.db.formBuilder.group({
      redeem_status: [data.redeem_status ? data.redeem_status : null ,[Validators.required]],
      redeem_status_remark: [data.redeem_status_remark ? data.redeem_status_remark : null ,[Validators.required]],
      redeem_request_id: [data.encrypt_id ? data.encrypt_id : null ,[Validators.required]],
      customer_id: [data.customer_id ? data.customer_id : 0 ,[Validators.required]],
    })
    console.log(this.form.value);
    
  }
  backClicked() {
    this._location.back();
  }
  
  onSubmit(){
    if(this.form.invalid){
      this.form.markAllAsTouched()
      return;
    }
    let reqData = this.form.value
    this.db.presentLoader();
    this.db.postReq(reqData,'redeem_request/update_redeem_status').subscribe(resp=>{
      this.db.dismissLoader();
      if(resp['status'] == 'success'){
        this.db.successAlert(resp['status'],resp['message']);
        this.db.matdialog.closeAll();
      }else{
        if(resp['message']=='Invalid token'){
          this.db.sessionExpire();
          return;
        }
        this.db.presentAlert(resp['status'],resp['message'])
      }
    },err=>{
      this.db.errHandler(err);
      this.db.errDismissLoader();
    })
    
  }
  
}
